<div
  class="tw-flex tw-rounded-lg tw-text-left tw-text-body-dark"
  [class]="backgroundClass"
  [class.tw-justify-items-center]="align === 'center'"
  [class.tw-justify-items-start]="align === 'top'"
  [class.tw-justify-items-end]="align === 'bottom'"
  [class.alert-bar--sm]="size === 'sm'"
  [class.alert-bar--lg]="size === 'lg'"
>
  <p-icon name="warning" [iconClass]="size === 'sm' ? '!tw-w-5 !tw-h-5' : ''"></p-icon>

  <div class="tw-text-body-dar">
    @if (title) {
      <div class="tw-mb-1.5 tw-font-bold" [innerHTML]="title | trustSrc"></div>
    }
    <div>
      <ng-content></ng-content>
    </div>
  </div>
</div>
